// extracted by mini-css-extract-plugin
export default {"outer":"BlogsCard_outer__bRR97","underLine":"BlogsCard_underLine__mkI14"};